module.exports = __webpack_public_path__ + "img/partseven_pic2.6309dec9.png";